import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { CustomerBanner } from "../../blocks/customer-banner";
import { CustomerCompany } from "../../blocks/customer-company";
import { CustomerHot } from "../../blocks/customer-hot";
import { HomeTryOn } from "../../blocks/home-try-on";
import { MainComment } from "../../blocks/main-comment";
import { SolutionCustomer } from "../../blocks/solution-customer";

import { Footer } from "../../components/FooterV2";

import { Header } from "../../components/Header";

import "./styles.less";

export const CustomerPage = () => {
  const { t } = useTranslation();
  return (
    <div className="customer-page">
      <Helmet>
        <title>
          SSO单点登录案例_统一身份认证客户案例_零信任网络案列-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode={"dark"} hasNotice />
      <CustomerBanner />
      <CustomerHot />
      <MainComment />
      <CustomerCompany />
      <SolutionCustomer />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
